<div class="page-container gap-24">
  <app-table-header-navigation
    [isLoading]="usersLoading"
    [slides]="cardSlides"
    (cardClicked)="onCardClicked($event)"></app-table-header-navigation>

  <app-custom-table
    class="padding-bottom-24"
    [pageSize]="50"
    [pageSizeOptions]="[5, 10, 25, 50, 100]"
    titleMultipleResults="Kontakte"
    titleSingleResult="Kontakt"
    [dataSource$]="dataSource$"
    [columns]="columns"
    [filters]="filters"
    [isLoading]="usersLoading"
    [tableHeaderDropdownMenu]="tableHeaderDropdown"
    noDataIcon="fa-users"
    noDataMessage="Es wurden keine Kontakte gefunden."
    noSearchResultsIcon="fa-users"
    noSearchResultsMessage="Es gibt keine Kontakte, die mit deinen Suchkriterien übereinstimmen.">
  </app-custom-table>
</div>
